module.exports = __webpack_public_path__ + "img/redis-list.a3fcb288.svg";